import { render, staticRenderFns } from "./collisionRecord.vue?vue&type=template&id=588c2c68&scoped=true"
import script from "./collisionRecord.vue?vue&type=script&lang=js"
export * from "./collisionRecord.vue?vue&type=script&lang=js"
import style0 from "./collisionRecord.vue?vue&type=style&index=0&id=588c2c68&prod&lang=less"
import style1 from "./collisionRecord.vue?vue&type=style&index=1&id=588c2c68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c2c68",
  null
  
)

export default component.exports